import { FC } from 'react'
import { IconProps } from '@chakra-ui/react'

import { StarCircle } from 'components/icons'

type Props = IconProps

const System: FC<Props> = (props) => {
  return <StarCircle {...props} />
}

const SystemExports = {
  System,
}

export default SystemExports
